module.exports = __webpack_public_path__ + "media/images/star-full-06f4f14bfe9fdaed110f2873bad2c4a1.svg";